import React, {Component} from 'react'
import { Waypoint } from 'react-waypoint'

import Player from '../Player/Player'
import Lock from '../Lock/Lock'

import './styles.scss'

class ChapterTwo extends Component {
    constructor(props) {
        super(props);
        this.state = { width: 0, height: 0 };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
        
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
        
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    render () {
        return (
            <>
                <Waypoint horizontal onEnter={()=>{this.props.chapterTransition("two")}}> 
                    <div className="chapter chapter-two chapter-2" style={{height: this.state.height + "px" }}>
                        <div className="scroll-container bg-back">
                            <div className="scroll scroll-two"></div>
                        </div>
                        <div className="scroll-container bg-front">
                            <div className="scroll"></div>
                        </div>
                        <div className="scroll-container bg-solid">
                            <div className="scroll"></div>
                        </div>
                        <div className="woodpecker"></div>
                        <div className="scroll-container one">
                            <div className="white-content scroll">
                                <h2>Har du sett eller hørt en hakkespett?</h2>
                                <p>Det finnes sju arter i Norge, og disse kan være små som spurver eller store som kråker. Det som er likt for alle de forskjellige hakkespettene er at de lager hus ved å hakke hull i trær med nebbene sine.</p>
                                <p>Hakkespetten flytter helst inn i trær som er gamle eller døde. De er morkne og myke, og lettere å hakke hull i enn unge trær.</p>
                            </div>
                            <Player file="2_1" />
                        </div>
                        <div className="scroll-container two">
                            <div className="green-content scroll">
                                <h2>Nebbet til hakkespetten vokser hele tiden, akkurat som håret og neglene dine.</h2>
                                <p>Det er bra siden nebbet blir slitt av all den hakk, hakk, hakkinga. Det er også en voldsom belastning for hodet når hakkespetten hamrer løs på et tre, og derfor er hakkespettens hjerne pakket inn i mykt vev. Det blir nesten som når du bruker sykkelhjelm, det!</p>
                            </div>
                            <Player file="2_2" />
                        </div>
                        <div className="scroll-container three">
                            <div className="white-content scroll">
                                <h2>Hakkespetten flytter oftere enn det folk gjør, gjerne en gang i året.</h2>
                                <p>Det betyr at det blir ledige reirhull, eller hus, i skogene der hakkespetten bor. Disse tomme husene er viktige for mange som ikke klarer å hakke reirhull selv, sånn som blåmeisen, kjøttmeisen, perleugla, stæren, ekornet og flaggermusa.</p>
                            </div>
                            <Player file="2_3" />
                        </div>
                        <div className="scroll-container four">
                            <div className="white-content scroll">
                                <h2>Det er altfor få døende eller døde trær i de norske skogene. </h2>
                                <p>Det betyr at det er færre trær som hakkespetten kan hakke i. Vi kan hjelpe hakkespetten ved å henge opp fuglekasser, men vi klarer ikke henge opp fuglekasser overalt. Derfor er det viktig at vi tar vare på de døde trærne i skogen vår.</p>
                            </div>
                            <Player file="2_4" />
                        </div>
                        <div className="scroll-container threes">
                            <div className="scroll"></div>
                        </div>
                        <div className="scroll-container three-rotten">
                            <div className="scroll"></div>
                        </div>
                        <div className="scroll-container squirrel">
                            <div className="scroll"></div>
                        </div>
                        <div className="scroll-container nesting-box">
                            <div className="nesting-box scroll"></div>
                        </div>
                        <div className="thank-you">Takk for at du skyller, bretter og stapper skolemelka for hakkespetten!</div>
                        <Lock 
                            progress="three"
                            handleModal={this.props.handleModal}
                            >
                        </Lock>
                    </div>
                </Waypoint>
            </>
        )
    }
}

export default ChapterTwo